import React, { memo } from "react"
import { Box, Text, Stack } from "@mos-cat/ds"
import { CustomGetUsersOptionLabel, getFormattedDate } from "@dit/core-frontend"

import styles from "../userProfilePage.module.css"

export const CommonUserInfo = memo(({ data }) => {
  const PERSON_CONFIG = [
    {
      title: "Полное имя",
      value: CustomGetUsersOptionLabel(data),
    },
    {
      title: "Имя в системе",
      value: data?.username,
    },
    // {
    //   title: "Дата рождения",
    //   value: getFormattedDate(data?.birthDate),
    // },
    // {
    //   title: "Email",
    //   value: data?.email,
    // },
    // {
    //   title: "Рабочий телефон",
    //   value: data?.phone,
    // },
    // временно скрыть
    // {
    //   title: "Мобильный телефон",
    //   value: data?.mobilePhone,
    // },
  ]

  const COMPANY_CONFIG = [
    {
      title: "Должность",
      value: data?.position,
    },
    // временно скрыть
    // {
    //   title: "Отдел",
    //   value: data?.department,
    // },
    // {
    //   title: "Адрес офиса",
    //   value: data?.address,
    // },
  ]

  return (
    <Stack marginRight="75px">
      <Box className={styles.title}>Данные</Box>
      <Stack marginBottom="20px">
        <Box className={styles.subtitle}>Персональные данные</Box>
        {PERSON_CONFIG.map((item) => {
          return (
            <Box key={item.title} marginTop="12px">
              <Text className={styles.field}>{item.title}</Text>
              <Text>{item.value || "-"}</Text>
            </Box>
          )
        })}
      </Stack>
      {/* <Stack>
        <Box className={styles.subtitle}>Компания</Box>
        {COMPANY_CONFIG.map((item) => {
          return (
            <Box key={item.title} marginTop="12px">
              <Text className={styles.field}>{item.title}</Text>
              <Text>{item.value || "-"}</Text>
            </Box>
          )
        })}
      </Stack> */}
    </Stack>
  )
})

CommonUserInfo.displayName = "CommonUserInfo"
